<template>
	<footer class="main-footer">
		<small class="main-footer__text"
			>©2019 COLORWAY GRAPHICS LTD. ALL RIGHTS RESERVED</small
		>
	</footer>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "SiteFooter",
	components: {}
});
</script>

<style lang="scss" scoped>
.main-footer {
	text-align: center;
	position: absolute;
	width: 100%;
	bottom: 0;

	&__text {
		font-style: normal;
		font-weight: bold;
		font-size: 12px;
		line-height: 16px;
		color: black;
	}
}
</style>